import React, { useState } from 'react'
import { CookieBanner } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import {
  isTrackingConsentExpired,
  saveTrackingConsent,
} from '../../utils/trackingConsent'

const TrackingConsentManager: React.FC = () => {
  const [showBanner, setShowBanner] = useState(isTrackingConsentExpired)
  const { t } = useTranslation('common')

  const handleConsent = (consent: boolean) => {
    saveTrackingConsent(consent)
    setShowBanner(false)
  }

  const handleReadMoreLinkClick = () => {
    window.location.assign(t('cookieConsent.readMoreLink'))
  }

  return (
    <CookieBanner
      show={showBanner}
      onAccept={handleConsent}
      onReadMoreLinkClick={handleReadMoreLinkClick}
      readMoreLink={t('cookieConsent.readMoreLinkText')}
    />
  )
}

export default TrackingConsentManager
